module.exports = __webpack_public_path__ + "static/media/3.d2ad2468.jpg";